<template lang="pug">
q-dialog(ref="dialog" @hide="onDialogHide")
  q-card.q-dialog-plugin(style="width: 700px; max-width: 70vw;")
    q-card-section.bg-secondary.text-white
      .text-h6 Správa obrázků
      .text-subtitle Označte obrázky, které mají být viditelné pro návštěvníky
    q-separator
    q-card-section.gallery_scroll
      gallery(:images='current')
        template(v-slot:default="{image}")
          q-img(:src="`${image.iiif}full/400,/0/default.png`" basic style="width: 100px")
            q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
              .text-caption {{ image.caption || '(popisek nenastaven)' }}
            .absolute-bottom.row.no-padding.justify-around
              q-btn(:icon="image.selected?'star':'star_border'" color="yellow" flat size="sm"
                @click.stop="selectImage(image)" :loading="image.submitting")
                q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
                  .text-caption(v-if="!image.selected") Použít v obrázkové galerii
                  .text-caption(v-if="image.selected") Použito v obrázkové galerii

    q-separator
    q-card-actions(align="right")
      q-btn(color="primary" flat label="Zavřít" @click="onOKClick")
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import Gallery from 'components/images/Gallery.vue'

export default @Component({
  props: {
    'images': Array,
    'storeSelection': Function
  },
  components: {
    'gallery': Gallery
  }
})
class SelectImagesDialog extends Vue {
  current = []

  mounted () {
    this.imagesChanged()
  }

  @Watch('images')
  imagesChanged () {
    this.current = this.images.map(x => ({ ...x, submitting: false }))
  }

  async selectImage (img) {
    img.selected = !img.selected
    img.submitting = true
    await this.storeSelection(img)
    img.submitting = false
  }

  show () {
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
  }

  onDialogHide () {
    this.$emit('hide')
  }

  async onOKClick () {
    this.$emit('ok', this.items)
    this.hide()
  }

  onCancelClick () {
    this.hide()
  }
}
</script>

<style lang="stylus">
.gallery_scroll
  max-height 65vh
  overflow-y scroll
</style>
